import { createUseStyles } from "react-jss";
import { useNavigate, useParams } from "react-router-dom";
import ScrapProductListingTemplate from "./ScrapProductListing.template";
import { useSnackbar } from "../../../../hooks/useSnackBar";
import { useEffect, useState } from "react";

import { useScrapProductService } from "../../../../services/useScrapProductService";
import { HTTP_STATUS, IPagination, MY_MATERIAL_STATE, SCRAP_STATE } from "../../../../utils/types";
import NoDataFrameTemplate from "../NoDataFrame.template";
import { UploadedImageData } from "../../../pages/CustomerManagement/FinishedProductCreation.page";
import Button from "../../../atoms/Button";
import { useBusinessProfileService } from "../../../../services/useBusinessProfileService";
import ButtonV2 from "../../../atoms/ButtonV2";
import { ADMIN_ROUTES } from "../../../../utils/constant";


const useStyles = createUseStyles((theme: any) => ({
    scrapProduct: {
        color: theme.palette.textV2.tertiary.tertiary700,
    }
}))

export interface ScrapProductsProps {
    id: number,
    scrapCategory: string,
    type: string,
    monthlyProduction: number,
    saleMode: string,
    images: UploadedImageData[]
}

interface ScrapProductTemplate {
    updateMaterialStateTo: (value: MY_MATERIAL_STATE) => void;
}

const ScrapProductTemplate: React.FC<ScrapProductTemplate> = ({ updateMaterialStateTo }) => {
    const classes = useStyles();
    const [scrapProducts, setScrapProducts] = useState<ScrapProductsProps[]>([]);
    const scrapProductService = useScrapProductService();
    const { showSnackbar, SnackBarComponent } = useSnackbar();
    const [pagination, setPaginationTo] = useState<IPagination>({
        pageSize: 10,
        totalRecords: 0,
        currentPage: 0,
        totalPages: 0
    });

    const handleAddNewProduct = () => {
        updateMaterialStateTo(MY_MATERIAL_STATE.SCRAP_CREATE);
    }

    const params = useParams();
    const businessId = Number(params.id);
    const bussinessProfileService = useBusinessProfileService();
    const [businessProfile, setBusinessProfileTo] = useState<{ userId: number } | null>(null);
    const navigate = useNavigate();

    const getBusinessProfile = async () => {
        try {
            const businessProfileResponse = await bussinessProfileService.getBusinessProfile(businessId);
            if (businessProfileResponse.status === HTTP_STATUS.OK) {
                const profileData = businessProfileResponse?.data?.data;
                setBusinessProfileTo(profileData);
            }
        } catch (error) {
            showSnackbar('error', 'Business Profile fetch failed');
        }
    };

    const loadScrapProduct = async () => {
        try {
            const scrapProduct = await scrapProductService.getAllScrapProducts(businessProfile?.userId as number, { size: pagination.pageSize, page: pagination.currentPage });
            if (scrapProduct.status === HTTP_STATUS.OK) {
                setScrapProducts(scrapProduct.data.data.content);
                setPaginationTo({
                    ...pagination,
                    totalPages: scrapProduct.data.data.totalPages,
                    totalRecords: scrapProduct.data.data.totalElements
                });
            }
        }
        catch (error) {
            showSnackbar("error", "Error Fetching Data");
        }
    }

    useEffect(() => {
        if (businessProfile)
            loadScrapProduct();
    }, [pagination.currentPage, pagination.pageSize, businessProfile])

    useEffect(() => {
        getBusinessProfile();
    }, [])

    const handleBackToDashboard = () => {
        navigate(ADMIN_ROUTES.CUSTOMER_MANAGEMENT_LIST);
    };

    return (
        <div className="grid gap-4 ">
            {SnackBarComponent}
            <div className="flex justify-between pb-4 border-b">
                <span className={`text-2xl font-medium ${classes.scrapProduct}`}>Scrap Listing</span>
                <ButtonV2 className='!font-medium' variant="primaryContained" label="+Add New Product" onClick={handleAddNewProduct} />
            </div>
            <div>
                {!!scrapProducts.length ?
                    <ScrapProductListingTemplate scrapProducts={scrapProducts} loadScrapProduct={loadScrapProduct} updateMaterialStateTo={updateMaterialStateTo} setPaginationTo={setPaginationTo} pagination={pagination} />
                    : <div className="mt-20">
                        <NoDataFrameTemplate title="No Result Found" message="You haven't provided Scrap for your business. " />
                    </div>}
            </div>
            <div className=' grid justify-items-stretch pt-6'>
                <ButtonV2
                    className={` justify-self-end`}
                    variant="secondaryContained"
                    label="Back to Dashboard"
                    onClick={handleBackToDashboard}
                />
            </div>
        </div>
    )
}

export default ScrapProductTemplate;